export default __webpack_public_path__ + "static/dario2-5f52d5afd6a5d03ca5899a7f3d697139.jpeg";